import React, { useEffect, useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "ah_cookie_consent_v1";

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) setVisible(true);
    } catch (_) { /* ignore */ }
  }, []);

  function acknowledge() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ value: "essentials_only", at: new Date().toISOString() }));
    } catch (_) { /* ignore */ }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[120] bg-ink text-cream rounded-sm shadow-xl border border-ink/80"
      role="dialog"
      aria-label={t("cookie_banner.header")}
      data-testid="cookie-banner"
    >
      <div className="p-5">
        <div className="flex items-start gap-3">
          <Cookie size={18} className="text-gold shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <div className="text-[11px] tracking-[0.2em] uppercase text-gold">{t("cookie_banner.header")}</div>
            <p className="mt-2 text-sm leading-relaxed text-cream/90">
              {t("cookie_banner.text")}
            </p>
            <div className="mt-3 flex flex-wrap items-center gap-3 text-xs">
              <Link to="/cookie-policy" className="underline text-cream hover:text-gold" data-testid="cookie-banner-policy">
                {t("cookie_banner.policy_link")}
              </Link>
              <span className="text-cream/40">·</span>
              <Link to="/privacy" className="underline text-cream hover:text-gold" data-testid="cookie-banner-privacy">
                {t("cookie_banner.privacy_link")}
              </Link>
            </div>
            <button
              onClick={acknowledge}
              className="mt-4 inline-flex items-center gap-2 bg-cream text-ink px-5 py-2.5 text-[11px] tracking-[0.2em] uppercase rounded-sm hover-lift"
              data-testid="cookie-banner-accept"
            >
              {t("cookie_banner.accept")}
            </button>
          </div>
          <button
            onClick={acknowledge}
            className="text-cream/60 hover:text-cream shrink-0"
            aria-label={t("cookie_banner.close")}
            data-testid="cookie-banner-close"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
